import React from "react";
import PropTypes from "prop-types";
import { Router, Switch, Route, Redirect } from "react-router-dom";
import history from "./history";
// import { AuthService } from "services";
import {
    App,
    AuthView,
    InboxView,
    ParticipatedView,
    CaseCreateView,
    DecisionDashboard,
    Datasheet,
    UsersAndGroupsView,
    CaseActionsView,
    UnderwritingView,
    ReportsPage,
    ReportsView,
    MpaView,
    DocumentChecklistViewPage,
    // AnchorOnBoarding,
    DistributorOnBoarding,
    NewCaseCreate,
    CaseDetailsDrawer,
    PskitCourierDetailsPage,
    CibilTable,
    AdhocCases,
    BulkUpload,
    PaymentProgramTable,
    PaymentProgramDetailsDrawer,
    MPAApproval,
    FounderCaseDetailsDrawer
} from "pages";
import {
    SchemeDrawerView,
    DocumentChecklistCreator
} from "templates";
import Companies from "./../modules/companies";
import Lenders from "./../modules/lenders";
import BankAccounts from "./../modules/virtual-accounts";
import { AUTH_STATUS } from "constants";
import DBOnboarding from "../templates/db-onboarding";
import AnchorOnboarding from "../templates/anchor-onboarding";
import { LeegalityPreviewNewPage } from "../modules/leegality/leegality-preview-new-page";
import FoundersCaseListing from "../templates/founders-credit-summary/case-listing-founders";
// import { AuthService } from "services";

export { history };

class AppRouter extends React.Component {
    componentDidMount() {
        const authState = this.props.store.getState();
        const pathname = history.location.pathname;
        if (authState === AUTH_STATUS.AUTHORIZED) {
            if (pathname.includes("/auth")) {
                history.replace("/app/inbox");
            }
        } else if (
            authState === AUTH_STATUS.INVALID_AUTHORIZATION_CREDENTIALS ||
            authState === AUTH_STATUS.UNAUTHORIZED
        ) {
            if (pathname.includes("/app")) {
                history.replace("/auth");
            }
        }
    }

    render() {
        return (
            <Router history={history}>
                <Switch>
                    <Route
                        exact={true}
                        path="/auth"
                        render={_ => <AuthView {..._} />}
                    />
                    <Route
                        exact
                        path="/"
                        render={() => <Redirect to={"/auth"} from="/" />}
                    />
                    <Route
                        exact={false}
                        path="/app/:pageID/"
                        render={props => (
                            <App {...props}>
                                 <Route
                                path="/app/preview/document"
                                render={props => (
                                    <LeegalityPreviewNewPage {...props} />
                                )}
                            />
                                <Route
                                    path="/app/participated"
                                    render={props => (
                                        <ParticipatedView {...props} />
                                    )}
                                />
                                <Route
                                    exact={true}
                                    path="/app/inbox"
                                    render={props => <InboxView {...props} />}
                                />
                                <Route
                                    exact={true}
                                    path="/app/case/:caseId"
                                    render={props => <FounderCaseDetailsDrawer {...props} />}
                                />
                                 <Route
                                    exact={true}
                                    path="/app/cases/list/"
                                    render={props => <FoundersCaseListing {...props} />}
                                />
                                <Switch>
                                    <Route
                                        exact={true}
                                        path={"/app/:pageID/:caseId/case_checklist"}
                                        render={props => <PaymentProgramDetailsDrawer {...props} />}
                                    />
                                    <Route
                                        path={"/app/:pageID/:caseId/:tabId"}
                                        render={props => {
                                            const { pageID, caseId } = props.match.params;
                                            if (pageID === "companies" && caseId === "sync") return null;
                                            return <CaseDetailsDrawer {...props} />;
                                        }}
                                    />
                                </Switch>

                                {/* <Route
                                    path={"/app/anchor-on-boarding"}
                                    component={AnchorOnBoarding}
                                /> */}

                                <Route
                                    path={"/app/distributor-on-boarding"}
                                    component={DistributorOnBoarding}
                                />
                                <Route
                                    path={"/app/case-create"}
                                    component={CaseCreateView}
                                />
                                <Route
                                    path={"/app/users-and-groups"}
                                    component={UsersAndGroupsView}
                                />
                                <Route
                                    path={"/app/datasheet-view"}
                                    component={Datasheet}
                                />
                                <Route
                                    path={"/app/inbox/decision-dashboard/:stageId"}
                                    component={DecisionDashboard}
                                />
                                {/* <Switch> */}

                                <Route
                                    exact={false}
                                    path={"/app/underwriting/jobs"}
                                    component={UnderwritingView}
                                />

                                <Route
                                    exact={false}
                                    path={"/app/mpa-approval/"}
                                    component={MPAApproval}
                                />

                                <Route
                                    exact={false}
                                    path={"/app/case/new"}
                                    component={NewCaseCreate}
                                />
                                <Route
                                    exact={true}
                                    path={"/app/pskit-courier-details"}
                                    component={PskitCourierDetailsPage}
                                />
                                <Route
                                    exact={true}
                                    path={"/app/cibil"}
                                    component={CibilTable}
                                />
                                <Route
                                    path={"/app/bulk-upload"}
                                    component={BulkUpload}
                                />
                                <Route
                                    exact={true}
                                    path={"/app/adhoc"}
                                    component={AdhocCases}
                                />
                                <Route
                                    path={"/app/payment-program/"}
                                    component={PaymentProgramTable}
                                />
                                <Switch>
                                    <Route
                                        path={"/app/db-onboarding/"}
                                        component={DBOnboarding}
                                    />

                                    <Route 
                                        path={"/app/anchor-onboarding/"}
                                        component={AnchorOnboarding}
                                    />

                                </Switch>
                                {/* </Switch> */}
                                <Route
                                    exact={true}
                                    path={"/app/reports"}
                                    component={ReportsPage}
                                />
                                <Route
                                    path="/app/reports/:reportId"
                                    component={ReportsView}
                                />
                                <Route
                                    path="/app/companies"
                                    component={Companies}
                                />
                                <Route
                                    path="/app/lenders"
                                    component={Lenders}
                                />
                                <Route
                                    path="/app/bank-accounts"
                                    component={BankAccounts}
                                />
                                <Switch>
                                    <Route
                                        exact={true}
                                        path={"/app/schemes"}
                                        component={MpaView}
                                    />
                                    <Route
                                        // exact={true}
                                        path={"/app/schemes/new"}
                                        component={SchemeDrawerView}
                                    />
                                    <Route
                                        // exact={true}
                                        path={"/app/schemes/:id"}
                                        component={SchemeDrawerView}
                                    />
                                </Switch>
                                <Switch>
                                    <Route
                                        exact={true}
                                        path={"/app/checklist"}
                                        component={DocumentChecklistViewPage}
                                    />
                                    <Route
                                        // exact={true}
                                        path={"/app/checklist/new"}
                                        component={DocumentChecklistCreator}
                                    />
                                    <Route
                                        // exact={true}
                                        path={"/app/checklist/:id"}
                                        component={DocumentChecklistCreator}
                                    />
                                </Switch>
                                <Route
                                    path={"/app/inbox"}
                                    render={props => (
                                        <CaseActionsView {...props} />
                                    )}
                                />
                                <Route path={"/app/lenders"} component={Lenders} />
                            </App>
                        )}
                    />
                    <Redirect path="/app" to="/app/inbox" />
                </Switch>
            </Router>
        );
    }
}

AppRouter.propTypes = {
    history: PropTypes.object,
    store: PropTypes.object
};

export default AppRouter;
